export default "__VITE_ASSET__BUTlEwta__"